<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ $t("chat") }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <allsupplier-chat :remove="classRemove"></allsupplier-chat>
    </template>
    <!-- <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal">
        {{ $t("close") }}
      </button>
    </template> -->
  </app-modal>
</template>

<script>
import { ModalMixin } from "../../../app/Mixins/ModalMixin";
import CoreLibrary from "../../../core/helpers/CoreLibrary.js";

export default {
  name: "FormList",
  extends: CoreLibrary,
  mixins: [ModalMixin],
  data() {
    return {
      modalId: "demo-add-edit-Modal",
      classRemove: true,
    };
  },
};
</script>